export function browserScheduleTimezone() {
  try { return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'; } catch (_) { return 'UTC'; }
}
export function inferTimeMode(mode, from, to) {
  if (['any', 'exact', 'window'].includes(mode)) return mode;
  return from && to && from.slice(0, 5) === to.slice(0, 5) ? 'exact' : from || to ? 'window' : 'any';
}
export function normalizeTime(value = {}) {
  const from = (value.time_from || '').slice(0, 5), to = (value.time_to || '').slice(0, 5);
  const mode = inferTimeMode(value.mode, from, to);
  return {mode, time_from: mode === 'any' ? '' : from, time_to: mode === 'any' ? '' : mode === 'exact' ? from || to : to};
}
export function modeValues(mode, value) {
  const prior = normalizeTime(value);
  if (mode === 'any') return {mode, time_from: '', time_to: ''};
  if (mode === 'exact') { const time = prior.time_from || prior.time_to; return {mode, time_from: time, time_to: time}; }
  return {mode, time_from: prior.time_from, time_to: prior.mode === 'exact' ? '' : prior.time_to};
}
export function restoreSchedule(order = {}, fallbackTimezone) {
  const global = normalizeTime({mode: order.preferred_time_mode, time_from: order.preferred_time_from, time_to: order.preferred_time_to});
  const saved = Array.isArray(order.desired_slots) ? order.desired_slots : [];
  const dates = saved.length ? saved.map(slot => slot.date) : order.desired_dates?.length ? order.desired_dates : order.desired_date ? [order.desired_date] : [];
  const byDate = new Map(saved.map(slot => [slot.date, slot]));
  return {schedule_timezone: order.schedule_timezone || fallbackTimezone || browserScheduleTimezone(), desired_dates: dates, desired_slots: dates.map(date => ({date, ...normalizeTime(byDate.get(date) || global)})),
    preferred_time_mode: global.mode, preferred_time_from: global.time_from, preferred_time_to: global.time_to};
}
export function changeDateSet(slots, dates) {
  const byDate = new Map(slots.map(slot => [slot.date, slot]));
  return [...new Set(dates)].sort().map(date => byDate.get(date) || {date, mode: 'any', time_from: '', time_to: ''});
}
export function schedulePayload(form) {
  if (form.desired_time === 'representative') return {desired_time: 'representative', desired_date: null,
    schedule_timezone: form.schedule_timezone || '', desired_dates: [], desired_slots: [], preferred_time_mode: 'any', preferred_time_from: null, preferred_time_to: null};
  if (form.desired_time === 'pick_dates') {
    const slots = (form.desired_slots || []).map(slot => {
      const value = normalizeTime(slot);
      return {date: slot.date, mode: value.mode, time_from: value.time_from || null, time_to: value.time_to || null};
    });
    return {desired_time: 'pick_dates', schedule_timezone: form.schedule_timezone || '', desired_date: null, desired_dates: slots.map(slot => slot.date), desired_slots: slots};
  }
  const value = normalizeTime({mode: form.preferred_time_mode, time_from: form.preferred_time_from, time_to: form.preferred_time_to});
  return {desired_time: form.desired_time || '', schedule_timezone: form.schedule_timezone || '', desired_date: form.desired_date || null, desired_dates: [], desired_slots: [],
    preferred_time_mode: value.mode, preferred_time_from: value.time_from || null, preferred_time_to: value.time_to || null};
}
export function formatScheduleTime(mode, from, to) {
  const value = normalizeTime({mode, time_from: from, time_to: to});
  if (value.mode === 'any') return 'любое время';
  if (value.mode === 'exact') return value.time_from ? `прибытие в ${value.time_from}` : 'время уточняется';
  if (value.time_from && value.time_to) return `прибытие с ${value.time_from} до ${value.time_to}`;
  return value.time_from ? `прибытие с ${value.time_from}` : value.time_to ? `прибытие до ${value.time_to}` : 'интервал уточняется';
}
export function scheduleErrors(form) {
  const value = schedulePayload(form);
  if (value.desired_time === 'representative') return '';
  if (value.desired_time === 'pick_dates' && 'schedule_timezone' in form && !value.schedule_timezone) return 'Выберите часовой пояс объекта.';
  const rows = value.desired_time === 'pick_dates' ? value.desired_slots : [{mode: value.preferred_time_mode, time_from: value.preferred_time_from, time_to: value.preferred_time_to}];
  if (value.desired_time === 'pick_dates' && !rows.length) return 'Выберите хотя бы одну дату или другой способ согласования.';
  for (const row of rows) {
    if (row.mode !== 'any' && (!row.time_from || !row.time_to)) return 'Заполните время прибытия для каждой выбранной даты.';
    if (row.mode === 'window' && row.time_to <= row.time_from) return 'Конец интервала должен быть позже начала в тот же день.';
  }
  return '';
}
